export default __webpack_public_path__ + "static/media/large-crumb2.5679d23b.png";